import { SideBar } from '../../models/sideBar.model';
import { assets } from './assets.const';
import { ModuleConst } from './module.const';

export const sideBar: SideBar[] = [
  {
    label: 'Dashboard',
    path: '/dashboard',
    img: assets.sidebarDashboardIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.DASHBOARD
  },

  {
    label: 'ManageCustomers',
    path: '/manage-customers',
    img: assets.UsersIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.CUSTOMERS
  },

  {
    label: 'Manage Service Provider',
    path: '/service-provider',
    img: assets.ServiceProviderIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.SERVICEPROVIDER
  },

  {
    label: 'Manage Bookings',
    path: '/bookings',
    img: assets.PropertyIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.BOOKINGS
  },
  {
    label: 'ManageCategories',
    path: '/category',
    img: assets.CategoryIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.CATEGORIES
  },
  {
    label: 'Manage Experience',
    path: '/manage-experience',
    img: assets.PackageIcon,
    isSubMenu: true,
    sideBarId: ModuleConst.PACKAGE,
    subMenuItems: [
      {
        label: 'Collections',
        path: '/collections',
        img: assets.PackageIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.COLLECTION
      },
      {
        label: 'Manage Package',
        path: '/packages',
        img: assets.PackageIcon,
        isSubMenu: false,
        sideBarId: 6011
      },
      {
        label: 'Manage Homestay',
        path: '/homestay',
        img: assets.HomestayIcon,
        isSubMenu: false,
        sideBarId: 6022
      },
      {
        label: 'Manage Events/Ticketing',
        path: '/ticketing',
        img: assets.PackageIcon,
        isSubMenu: false,
        sideBarId: ModuleConst.TICKETING
      },
      {
        label: 'CurationQueue',
        path: '/ticketing/curation-queue',
        img: assets.PackageIcon,
        isSubMenu: false,
        sideBarId: 6033
      }
    ]
  },
  {
    label: 'Manage Payment',
    path: '/revenue',
    img: assets.RevenueIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.PAYMENT
  },
  {
    label: 'Manage Guide',
    path: '/guide',
    img: assets.GuideIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.GUIDE
  },

  // {
  //   label: 'Manage Package',
  //   path: '/packages',
  //   img: assets.PackageIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.PACKAGE
  // },
  // {
  //   label: 'Manage Ticketing',
  //   path: '/ticketing',
  //   img: assets.PackageIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.TICKETING
  // },
  // {
  //   label: 'Manage Homestay',
  //   path: '/homestay',
  //   img: assets.HomestayIcon,
  //   isSubMenu: false,
  //   sideBarId: ModuleConst.HOMESTAY
  // },

  {
    label: 'Manage Banner',
    path: '/banner',
    img: assets.BannerIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.BANNER
  },
  {
    label: 'Manage Deals',
    path: '/deals',
    img: assets.DealIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.DEALS
  },

  {
    label: 'Reports and Analytics',
    path: '/reports',
    img: assets.ReportIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.REPORTANALYTICS
  },
  {
    label: 'Manage Reviews',
    path: '/review',
    img: assets.ReviewIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.REVIEWS
  },

  {
    label: 'Manage Sub-Admin',
    path: '/subadmin',
    img: assets.SubadminIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.SUBADMIN
  },

  {
    label: 'Manage Chat',
    path: '/chat',
    img: assets.ChatIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.CHAT
  },
  {
    label: 'CustomerSupport',
    path: '/manage-customer-support',
    img: assets.DestinationIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.SUPPORT
  },
  {
    label: 'NotificationManagement',
    path: '/notification',
    img: assets.NotificationIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.NOTIFICATIONS
  },
  {
    label: 'ManageSettings',
    path: '/settings',
    img: assets.SettingsIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.SETTINGS
  },
  {
    label: 'ManageCMS',
    path: '/cms',
    img: assets.CmsIcon,
    isSubMenu: false,
    sideBarId: ModuleConst.CMS
  }
];


